import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const propTypes = {
    enabled: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.obj, //shoud be a component
    text: PropTypes.obj, //should be a component
};

class PopOverCell extends PureComponent {
    state = {};

    renderIcon = () => {
        const { iconClassNames = [], icon } = this.props;

        return <div className={['fm-popover-cell-icon', ...iconClassNames].join(' ')}>{icon}</div>;
    };

    renderText = () => {
        const { textClassNames = [], text, icon } = this.props;

        !icon && textClassNames.push('without-icon');

        return <div className={['fm-popover-cell-text', ...textClassNames].join(' ')}>{text}</div>;
    };

    onClick = () => {
        const { enabled, onClick } = this.props;
        if (!enabled) return;
        onClick && onClick();
    };

    render() {
        const { icon, text, enabled } = this.props;

        const PopoverCellContainerClass = ['fm-popover-cell', enabled ? '' : 'disabled'].join(' ');

        return (
            <div className={PopoverCellContainerClass} onClick={this.onClick}>
                {icon && this.renderIcon()}
                {text && this.renderText()}
            </div>
        );
    }
}

PopOverCell.propTypes = propTypes;

export default PopOverCell;
